import { useForm } from "react-hook-form"
import { useContext } from "react";
import { ToastDataContext } from "./context/ToastContextProvider";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"
import { classNames } from "./App";
import ErrorManagement, { addErrorToClass } from "./components/errormanagement";
import { resetPasswordEndpoint } from "./hr_endpoints";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ForgotPassword({ }) {

    const { t } = useTranslation();

    const schema = yup.object({
        email: yup.string().email(t("forgotPassword.invalidEmail")).required(t("forgotPassword.requiredField"))
    })

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema)
    })

    const toastContext = useContext(ToastDataContext)

    const onSubmit = async (data) => {
        const response = await fetch(resetPasswordEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })

        if (!response.ok) {
            toastContext.error(await response.text());
        } else {
            toastContext.success(t("forgotPassword.success"))
            reset()
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="card w-full max-w-md shadow-2xl bg-base-100 animate__animated animate__fadeIn animate__faster">

                <div className="card-body">
                    <div className="flex flex-col items-center gap-2 mb-4">
                        <div className="placeholder">
                            <img
                                alt="TeamUp Logo"
                                src="/logo.svg"
                                className="h-40 w-auto mb-[-3rem]"
                            />
                        </div>
                        <h2 className="mt-4 text-2xl font-bold">{t("forgotPassword.welcome")}</h2>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">{t("forgotPassword.email")}</span>
                            </label>
                            <input type="email" {...register('email')} className={classNames("input input-bordered hover:input-primary focus:input-primary", addErrorToClass(errors.email))} required />
                            <ErrorManagement errorObj={errors.email} />
                            <label className="label">
                                <span></span>
                                <Link to={"/login/admin"}><label className="label-text-alt link link-primary hover:link-primary-focus">{t("forgotPassword.login")}</label></Link>
                            </label>
                        </div>

                        <div className="form-control mt-6">
                            <button className="btn bg-primary hover:bg-primary-dark">
                                {t("forgotPassword.send")}
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

}